module.exports = __webpack_public_path__ + "static/img/case-solution-diagram-04.9aad0bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-solution-diagram-04.png
// module id = b9zO
// module chunks = 1